import type { SubjectTypeGrantPayload } from '@Application/SubjectTypeDefinitions/Actions/subjectTypeDefinitionsFetched';

export type BeneficiaryTypeGrantsPayload = {
	readonly usableBy: readonly SubjectTypeGrantPayload[];
};

export type BeneficiaryTypeGrantsFetchedAction = {
	type: 'BENEFICIARY_TYPE_GRANTS_FETCHED';
	payload: BeneficiaryTypeGrantsPayload;
	accountId: number;
};

export default (
	payload: BeneficiaryTypeGrantsPayload,
	accountId: number,
): BeneficiaryTypeGrantsFetchedAction => ({
	type: 'BENEFICIARY_TYPE_GRANTS_FETCHED',
	payload,
	accountId,
});
